import styled from 'styled-components';
import { Button } from '@hqo/react-components-library/dist/atoms/button';
import { DIMENSIONS } from '@hqo/react-components-library/dist/utils';

export const SwitchContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ButtonStyled = styled(Button)`
  margin-top: auto;
  height: 50px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px;

  @media screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    padding: 16px 16px 35px 16px;
    height: 100%;
    box-sizing: border-box;
  }
`;

export const Title = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
`;

export const FieldWrapper = styled.div`
  margin: 8px 0;
`;
